import { IonApp, setupIonicReact } from '@ionic/react';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/theme.css';

import { useEffect } from 'react';

import AppProvider from './lib/context/AppContext';
import Root from './pages/Root';

import OneSignal from 'onesignal-cordova-plugin';
import {
  AppTrackingTransparency,
  AppTrackingStatusResponse,
} from 'capacitor-plugin-app-tracking-transparency';

setupIonicReact();

// Call this function when your app starts

const App: React.FC = () => {
  const DeviceReadyInit = async () => {
    /**
     * ONE SIGNAL
     */
    // Uncomment to set OneSignal device logging to VERBOSE
    // OneSignal.setLogLevel(6, 0);

    // NOTE: Update the setAppId value below with your OneSignal AppId.
    OneSignal.setAppId('4bc0e38c-f619-41ef-a41c-91ba0bfb64fc');

    // Prompts the user for notification permissions.
    //    * Since this shows a generic native prompt, we recommend instead using an In-App Message to prompt for notification permission (See step 7) to better communicate to your users what notifications they will get.
    OneSignal.promptForPushNotificationsWithUserResponse((accepted) => {});

    OneSignal.setNotificationWillShowInForegroundHandler(function (
      notificationReceivedEvent
    ) {
      notificationReceivedEvent.complete(
        notificationReceivedEvent.getNotification()
      );
      window.document.dispatchEvent(
        new CustomEvent('showForegroundNotification', {
          detail: notificationReceivedEvent.getNotification(),
        })
      );
    });
    // OneSignal.setInAppMessageLifecycleHandler

    OneSignal.setNotificationOpenedHandler(function (openedEvent) {
      // https://documentation.onesignal.com/docs/osnotification-payload
      let { action, notification } = openedEvent;
      window.document.dispatchEvent(
        new CustomEvent('openNotification', { detail: notification })
      );
    });

    /**
     * AUTHORIZATIONS
     */

    AppTrackingTransparency.requestPermission();
  };

  useEffect(() => {
    window.document.addEventListener('deviceready', DeviceReadyInit, false);
  }, [window]);

  return (
    <IonApp>
      <AppProvider>
        <Root />
      </AppProvider>
    </IonApp>
  );
};

export default App;
